import { validatePresence } from 'ember-changeset-validations/validators';
import { customMessageValidator } from 'uplisting-frontend/validators/custom-message';
import { validateCoordinate } from 'uplisting-frontend/validators/coordinate';

export const AddressValidation = {
  street: customMessageValidator(
    'address_street',
    validatePresence({
      presence: true,
      ignoreBlank: true,
    }),
  ),

  city: customMessageValidator(
    'address_city',
    validatePresence({
      presence: true,
      ignoreBlank: true,
    }),
  ),

  state: customMessageValidator(
    'address_state',
    validatePresence({
      presence: true,
      ignoreBlank: true,
    }),
  ),

  zipCode: customMessageValidator(
    'address_zipCode',
    validatePresence({
      presence: true,
      ignoreBlank: true,
    }),
  ),

  latitude: [validateCoordinate('address_latitude', { min: -90, max: 90 })],

  longitude: [validateCoordinate('address_longitude', { min: -180, max: 180 })],
};
